import { ItemView, locale } from '@glu/core';

import template from './loadingViewText.hbs';

export default ItemView.extend({
  template,
  className: 'glu-content-loading',

  templateHelpers() {
    return {
      text: this.options.text || locale.get('loading')
    };
  }
});
